import { Injectable } from '@angular/core';
import { ZingChartService } from './zing-chart.service';

declare var zingchart: any;
@Injectable()
export class RenderZingChartService {

  constructor(private zingChartService: ZingChartService) { }

  renderZingCharts(id, config) {
    zingchart.render({
      id: id,
      data: config,
      height: "100%",
      width: "100%",
      defaults: this.zingChartService.getZingChartTheme()
    });
  }

  renderZingCharts2(id, config) {
    zingchart.exec(id,'destroy');
    zingchart.render({
      id: id,
      data: config,
      height: "100%",
      width: "100%"
    });
  }

  getChartConfig(params) {
    var myTitle = params['myTitle'];
    var data = params['data'];
    var type = params['type'];
    var myConfig = {
      "type": type,
      "title": {
        "text": myTitle,
        "fontSize": 14,
      },
      "scale-x": {
        "visible": true,
        "item": {
          "font-color": "#fff"
        }
      },
      "scale-y": {
        "visible": false
      },
      "legend": {
        "layout": "4x1",
        "border-width": 0,
        "vertical-align": "bottom",
        "align": "center",
        "margin": 0,
        "margin-bottom": "6%",
        "item": {
          "font-size": "13px",
        },
        "marker": {
          "type": "circle",
          "border-color": "none"
        },
      },
      "plotarea": {
        "margin-top": "20%",
        "margin-bottom": "20%"
      },
      "series": data
    };

    myConfig['scale-x'] = params['xLabel'];

    if (params['labels']) {
      myConfig['labels'] = params['labels'];
    }

    myConfig['legend']['visible'] = params['legend'];
    if(params['marker'])
      myConfig['legend']['marker'] = params['marker'];
    myConfig['gui'] = this.zingChartService.getConfigProperty();

    if (params['plot']) {
      myConfig['plot'] = params['plot'];
    }
    if (params['yLabel']) {
      myConfig['scale-y'] = params['yLabel'];
    }
    if (params['layout']) {
      myConfig['legend']['layout'] = params['layout']
    }
    return myConfig;
  }


  getChartConfig2(params) {
    var myTitle = params['myTitle'];
    var data = params['data'];
    var type = params['type'];
    var myConfig = {
      "type": type,
      "title": {
        "text": myTitle,
        "fontSize": 14,
      },
      "scale-x": {
        "visible": true,
        "item": {
          "font-color": "#E0F6EA"
        }
      },
      "scale-y": {
        "visible": true
      },
      "legend": {
        "layout": "4x1",
        "border-width": 0,
        "vertical-align": "bottom",
        "align": "center",
        "margin": 0,
        "margin-bottom": "6%",
        "item": {
          "font-size": "13px",
        },
        "marker": {
          "type": "circle",
          "border-color": "none"
        },
      },
      "plotarea": {
        "margin-top": "20%",
        "margin-bottom": "20%"
      },
      "series": data
    };

    myConfig['scale-x'] = params['xLabel'];

    if (params['labels']) {
      myConfig['labels'] = params['labels'];
    }

    myConfig['legend']['visible'] = params['legend'];
    if(params['marker'])
      myConfig['legend']['marker'] = params['marker'];
    myConfig['gui'] = {contextMenu: {
      button: {
        visible: false
      }
    }}
    

    if (params['plot']) {
      myConfig['plot'] = params['plot'];
    }
    if (params['yLabel']) {
      myConfig['scale-y'] = params['yLabel'];
    }
    if (params['layout']) {
      myConfig['legend']['layout'] = params['layout']
    }
    myConfig['plot'].hoverState ={
      backgroundColor: '#009688'
    }
    myConfig['plot'].borderRadiusTopLeft= 25;
    myConfig['plot'].borderRadiusTopRight= 25;
    return myConfig;
  }

  wordCloudChart(text, id) {
    let myConfig = {
      type: 'wordcloud',
      options: {
        text: text,
        minLength: 5,
        // ignore: ['establish', 'this', 'thereof', 'details', 'whether', 'Government', "i", "me", "my", "myself", "we", "our", "ours", "ourselves", "you", "your", "yours", "yourself", "yourselves", "he", "him", "his", "himself", "she", "her", "hers", "herself", "it", "its", "itself", "they", "them", "their", "theirs", "themselves", "what", "which", "who", "whom", "this", "that", "these", "those", "am", "is", "are", "was", "were", "be", "been", "being", "have", "has", "had", "having", "do", "does", "did", "doing", "a", "an", "the", "and", "but", "if", "or", "because", "as", "until", "while", "of", "at", "by", "for", "with", "about", "against", "between", "into", "through", "during", "before", "after", "above", "below", "to", "from", "up", "down", "in", "out", "on", "off", "over", "under", "again", "further", "then", "once", "here", "there", "when", "where", "why", "how", "all", "any", "both", "each", "few", "more", "most", "other", "some", "such", "no", "nor", "not", "only", "own", "same", "so", "than", "too", "very", "s", "t", "can", "will", "just", "don", "should", "now", "taken", "state", "State", "States", "said", "year", "wise", "pleased"],
        maxItems: 40,
        aspect: 'flow-center',
        rotate: false,
        colorType: 'palette',
        palette: ['#1D6AA7', '#0F7AD1'],
      }
    };

    zingchart.render({
      id: id,
      data: myConfig,
      height: 300,
      width: '100%'
    });
  }

  barChart(data, x_lable, id) {
    let params = {
      // 'myTitle': res,
      'data': data,
      'type': 'bar',
      'legend': true,
      "layout": '2x2',
      "plotarea": {
        "margin": "dynamic",
        "margin-top": "20%",
        "adjust-layout": true
      },
      "plot": {
        "value-box": {
          "text": "%v",
          "background-color": "#fff",
          "border-width": 0,
          "border-color": "#666699",
          "shadow": true,
          "thousands-separator": ",",
          "padding": "10%",
          "callout": true
        }
      },
      "xLabel": {
        visible: true,
        "item": {
          "font-color": "#004A43",
          "font-size":"16px"
        },
        "labels": x_lable
      }
    };
    this.renderZingCharts(id, this.getChartConfig(params));
  }


  barChart2(data, x_lable, id) {
    let params = {
      // 'myTitle': res,
      'data': data,
      'type': 'bar',
      'legend': false,
      "layout": '2x2',
      "plotarea": {
        "margin": "dynamic",
        "margin-top": "20%",
        "adjust-layout": true
      },
      "plot": {
        "value-box": {
          "text": "%v",
          "background-color": "#fff",
          "border-width": 0,
          "border-color": "#666699",
          "shadow": true,
          "thousands-separator": ",",
          "padding": "10%",
          "callout": true
        },
        "tooltip": { //Standard Tooltips
          "text": "%v <br> %kl",
          "placement": "node:top",
          "padding": "10%",
          "border-radius": "5px"
        }
      },
      "xLabel": {
        visible: true,
        "item": {
          "font-color": "#004A43",
          "font-size":"16px"
        },
        "labels": x_lable
      },
      "gui":'{ <br>  "contextMenu":{ <br>    "button":{ <br>      "visible": false <br>    } <br>  } <br>}, <br>'
    };
    this.renderZingCharts2(id, this.getChartConfig2(params));
  }

  responseBarChart(data, x_lable, id) {
    let params = {
      'data': data,
      'type': 'bar',
      'legend': false,
      "layout": '2x2',
      "plotarea": {
        "margin": "dynamic",
        "margin-top": "20%",
        "adjust-layout": true
      },
      "plot": {
        "value-box": {
          "text": "%v",
          "background-color": "#fff",
          "border-width": 0,
          "border-color": "#666699",
          "shadow": true,
          "thousands-separator": ",",
          "padding": "10%",
          "callout": true
        },
        "tooltip": {
          "text": "%v : %kt ",
          "font-color": "black",
          "font-family": "Georgia",
          "text-alpha": 1,
          "background-color": "white",
          "alpha": 0.9,
          "border-width": 1,
          "border-color": "#cccccc",
          "line-style": "dotted",
          "border-radius": "10px",
          "padding": "10%",
          "placement": "node:center",
          "thousands-separator": ","
        }
      },
      "xLabel": {
        visible: true,
        "labels": x_lable,
        // transform: {
        //   type: 'date',
        //   all: '%dd %M'
        // }
      },
      "yLabel": {
        visible: true
      }
    };
    this.renderZingCharts(id, this.getChartConfig(params));
  }

  ratingBarChart(data, id) {
    let params = {
      // 'myTitle': res,
      'data': data,
      'type': 'bar',
      'legend': true,
      "layout": '1x5',
      "plotarea": {
        "margin": "dynamic",
        "margin-top": "20%",
        "adjust-layout": true
      },
      "plot": {
        "value-box": {
          "text": "%v",
          "background-color": "#fff",
          "border-width": 0,
          "border-color": "#666699",
          "shadow": true,
          "thousands-separator": ",",
          "padding": "10%",
          "callout": true
        }
      },
      "xLabel": {
        visible: true,
        "item": {
          "font-color": "#fff"
        }
      },
      marker: {
        type: "star5"
      }
    };
    this.renderZingCharts(id, this.getChartConfig(params));
  }

  emojiBarChart(data, id){
    let params = {
      'data': data,
      'type': 'bar',
      'legend': false,
      "layout": '2x2',
      "plotarea": {
        "margin": "dynamic",
        "margin-top": "20%",
        "margin-bottom": "20%",
        "margin-left": "10%",
        "margin-right": "10%",
      },
      "plot": {
        "value-box": {
          "text": "%v",
          "background-color": "#fff",
          "border-width": 0,
          "border-color": "#666699",
          "shadow": true,
          "thousands-separator": ",",
          "padding": "10%",
          "callout": true
        }
      },
      "xLabel" : {
        visible : true,
        item : { 
          "font-color" : "#fff",
          "font-size" : 0
        }
      },
      "labels" : [
        {
          // text: 'Highly satisfied',
          backgroundImage: '../../../assets/images/sentiment_very_satisfied.png',
          hook: 'scale:name=scale-x,index=0',
          offsetY: '25px',
          width: '25px',
          height: '25px'
        },
        {
          // text: 'Happy',
          backgroundImage: '../../../assets/images/sentiment_satisfied.png',
          hook: 'scale:name=scale-x,index=1',
          offsetY: '25px',
          width: '25px',
          height: '25px'
        },
        {
          // text: 'Satisfied',
          backgroundImage: '../../../assets/images/sentiment_neutral.png',
          hook: 'scale:name=scale-x,index=2',
          offsetY: '25px',
          width: '25px',
          height: '25px'
        },
        {
          // text: 'Content',
          backgroundImage: '../../../assets/images/sentiment_dissatisfied.png',
          hook: 'scale:name=scale-x,index=3',
          offsetY: '25px',
          width: '25px',
          height: '25px'
        },
        {
          // text: 'Highly dissatisfied',
          backgroundImage: '../../../assets/images/sentiment_very_dissatisfied.png',
          hook: 'scale:name=scale-x,index=4',
          offsetY: '25px',
          width: '25px',
          height: '25px'
        }]
    };
    this.renderZingCharts(id, this.getChartConfig(params));
  }

  rankBarChart(data, id) {
    let params = {
      'data': data,
      'type': 'hbar',
      'legend': true,
      "layout": '1x5',
      "plotarea": {
        "margin": "dynamic",
        "margin-top": "20%",
        "adjust-layout": true
      },
      "plot": {
        "stacked": true,
        'stack-type': "normal"
      },
      "xLabel": {
        visible: true,
        "item": {
          "font-color": "#fff"
        }
      }
    };
    this.renderZingCharts(id, this.getChartConfig(params));
  }

  pieChartsCombinedConfig(data, label, legend, slice) {
    var myConfig = {
      "title": {
        "text": '',
        "fontSize": 14,
        "thousands-separator": ","
      },
      "type": "pie",
      "plotarea": {
        "margin": "dynamic",
        "adjust-layout": true,
      },
      "legend": {
        "layout": "2x2",
        "border-width": 0,
        "vertical-align": "bottom",
        "align": "left",
        "margin": 0,
        "margin-bottom": "6%",
        "item": {
          "font-size": "13px",
        },
        "marker": {
          "type": "circle",
          "border-color": "none"
        }
      },
      "plot": {
        "tooltip": {
          "text": "%v",
          "font-color": "black",
          "font-family": "Georgia",
          "text-alpha": 1,
          "background-color": "white",
          "alpha": 0.9,
          "border-width": 1,
          "border-color": "#cccccc",
          "line-style": "dotted",
          "border-radius": "10px",
          "padding": "10%",
          "placement": "node:center",
          "thousands-separator": ","
        },
        "border-width": 1,
        "border-color": "#cccccc",
        "slice": slice
      },
      "series": data
    };
    myConfig.plot["value-box"] = this.zingChartService.valueBox;
    myConfig.plot["value-box"]["rules"] = [
      {
        "rule": "%v < 1",
        "visible": "false"
      }
    ];

    if (legend! = undefined) {
      myConfig["legend"] = legend;
    }
    if (label != undefined) {
      myConfig["labels"] = label;
    }

    myConfig['gui'] = this.zingChartService.getConfigProperty();
    return myConfig;
  }

  lineChart(params) {
    var myTitle = params['title'];
    var data = params['data'];
    var myConfig = {
      "type": 'line',
      "title": {
        "text": myTitle,
        "fontSize": 14,
      },
      "plotarea": {
        "margin-top": "20%",
        "margin-bottom": "20%",
        "margin-left": "10%",
        "margin-right": "10%"
      },
      "plot": {
        // "value-box": {
        //     "placement": 'middle',
        //     "text": "%v",
        //     "background-color": "#fff",
        //     "border-width": 0,
        //     "decimals": 2,
        //     "border-color": "#666699",
        //     "shadow": true,
        //     "padding": "10%",
        //     "font-size" : 13,
        //     "color" : "black",
        //     "callout": true,
        //     "rules": [ {    "rule": "%v < 0",  "visible": false}]
        // },
      },
      "scale-x": {
        "labels": params['Xlabel'],
        "label" : {text : params['XlabelText'] ? params['XlabelText'] : ''},
        "item": {
          "angle": -45
        },
        "visible": true
      },
      "scale-y": {
        "visible": true
      },
      marker: {
        size: 7,
        borderWidth: 2
      },
      "legend": {
        visible : false, //No text to show for legend
        "layout": "3x1",
        "border-width": 0,
        "vertical-align": "bottom",
        "align": "center",
        "margin": 0,
        "margin-bottom": "6%",
        "margin-top": "0%",
        "item": {
          "font-size": "13px",
        },
        "marker": {
          "type": "circle",
          "border-color": "none"
        },
      },
      "series": data
    };
    myConfig['gui'] = this.zingChartService.getConfigProperty();
    return myConfig;
  }

  sunBurstPie(params) {
    var myTitle = params['title'];
    var data = params['data'];
    var myConfig = {
      "type": 'sunburst',
      "title": {
        "text": myTitle,
        "fontSize": 14,
      },
      options: {
        palette: ['#009688','#FFA17A','#E39217','#1F78C1','#965D08','#7163B4','#344B47','#48B691',
        '#928719','#F97DEA'],
      },
      "plotarea": {
        "margin-top": "20%",
        "margin-bottom": "20%",
        "margin-left": "10%",
        "margin-right": "10%"
      },
      "plot": {
        "tooltip": {
          align: 'left',
          "text": "%v",
          "font-color": "black",
          "font-family": "Georgia",
          "text-alpha": 1,
          "background-color": "white",
          "alpha": 0.9,
          "border-width": 1,
          "border-color": "#cccccc",
          "line-style": "dotted",
          "border-radius": "10px",
          "padding": "10%",
          "placement": "node:center",
          "thousands-separator": ","
        },
        valueBox: {
          text: '%data-vbtext',
          color: '#424242',
          fontSize: '10px',
          visible: null
        }
      },
      "scale-x": {
        "labels": params['Xlabel'],
        "item": {
          "angle": -45
        },
        "visible": true
      },
      "scale-y": {
        "visible": true
      },
      marker: {
        size: 7,
        borderWidth: 2
      },
      "legend": {
        visible : false, //No text to show for legend
        "layout": "3x1",
        "border-width": 0,
        "vertical-align": "bottom",
        "align": "center",
        "margin": 0,
        "margin-bottom": "6%",
        "margin-top": "0%",
        "item": {
          "font-size": "13px",
        },
        "marker": {
          "type": "circle",
          "border-color": "none"
        },
      },
      "series": data
    };
    myConfig['gui'] = this.zingChartService.getConfigProperty();
    return myConfig;
  }

  rangeChart(params) {
    var myTitle = params['title'];
    var data = params['data'];
    var myConfig = {
      "type": 'range',
      "title": {
        "text": myTitle,
        "fontSize": 14,
      },
      "plotarea": {
        "margin-top": "20%",
        "margin-bottom": "20%",
        "margin-left": "10%",
        "margin-right": "10%"
      },
      "plot": {
        // "value-box": {
        //     "placement": 'middle',
        //     "text": "%v",
        //     "background-color": "#fff",
        //     "border-width": 0,
        //     "decimals": 2,
        //     "border-color": "#666699",
        //     "shadow": true,
        //     "padding": "10%",
        //     "font-size" : 13,
        //     "color" : "black",
        //     "callout": true,
        //     "rules": [ {    "rule": "%v < 0",  "visible": false}]
        // },
      },
      "scale-x": {
        "labels": params['Xlabel'],
        "label" : {text : params['XlabelText'] ? params['XlabelText'] : ''},
        "item": {
          "angle": -45
        },
        "visible": true
      },
      "scale-y": {
        "visible": true
      },
      marker: {
        size: 7,
        borderWidth: 2
      },
      "legend": {
        visible : false, //No text to show for legend
        "layout": "3x1",
        "border-width": 0,
        "vertical-align": "bottom",
        "align": "center",
        "margin": 0,
        "margin-bottom": "6%",
        "margin-top": "0%",
        "item": {
          "font-size": "13px",
        },
        "marker": {
          "type": "circle",
          "border-color": "none"
        },
      },
      "series": data
    };
    myConfig['gui'] = this.zingChartService.getConfigProperty();
    return myConfig;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/render.zingchart.service.ts